import { render, staticRenderFns } from "./classical-exam-sessions.vue?vue&type=template&id=54b00b32"
import script from "./classical-exam-sessions.vue?vue&type=script&lang=js"
export * from "./classical-exam-sessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports